export const header = [
  {
    text: 'Khoản phí thu/đóng',
    value: 'title',
    align: 'left',
    sortable: false,
    show: true,
    width: '30%',
  },
  {
    text: 'Mức phí (VNĐ)',
    value: 'headFee',
    align: 'right',
    sortable: false,
    show: true,
    width: '10%',
  },
  {
    text: 'Giảm trừ (VNĐ)',
    value: 'deductionHeadFees',
    align: 'right',
    sortable: false,
    show: true,
    width: '10%',
  },
  {
    text: 'Truy thu (VNĐ)',
    value: 'arrearFees',
    align: 'right',
    sortable: false,
    show: true,
    width: '10%',
  },
  {
    text: 'Hoàn trả (VNĐ)',
    value: 'refundFees',
    align: 'right',
    sortable: false,
    show: true,
    width: '10%',
  },
  {
    text: 'Tổng (VNĐ)',
    value: 'total',
    align: 'right',
    sortable: false,
    show: true,
    width: '10%',
  },
  {
    text: 'Đã thu (VNĐ)',
    value: '',
    align: 'right',
    sortable: false,
    show: true,
    width: '10%',
  },
  {
    text: 'Còn thiếu (VNĐ)',
    value: '',
    align: 'right',
    sortable: false,
    show: true,
    width: '10%',
  },
]
